// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__AfQ5+","fullWidth":"style_fullWidth__38-Yp","small":"style_small__k9gNO"};